import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Flexbox, FlexboxCenter } from './Layout';

const Wrapper = styled(Flexbox)`
  justify-content: space-between;
  padding: 0 6rem;
`;

const Circle = styled(FlexboxCenter)`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: ${({ active }: any) => active ? Colors.primary : Colors.gray};
  color: ${Colors.white};
  font-size: 1.125rem;
  line-height: 1;
  overflow: hidden;
  white-space: nowrap;
  flex-shrink: 0;
  border: 3px solid ${({ active }: any) => active ? Colors.primaryLight : Colors.gray};
`;
const Title = styled.div`
  color: ${({ active }: any) => active ? Colors.primary : Colors.gray};
  display: ${({ current }: any) => current ? 'block' : 'none'};
  font-size: .875rem;
  line-height: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-shrink: 0;
  padding: 0 .25rem;
`;
const Line: any = styled.div`
  flex: 1;
  min-width: ${({ beginning }: any) => beginning ? '.5rem' : '2rem'};
  ${({ beginning }: any) => beginning ? 'flex-grow: 0;' : ''}
  height: 2px;
  background: ${({ active, current, beginning = false }: any) => active && !current || beginning ? Colors.primary : Colors.gray};
`;
const LineWrapper: any = styled(Flexbox)`
  flex: 1;
`;

interface Props {
  items: WizardItemProps[];
}
export const Wizard: FC<Props> = (props) => {
  return (
    <Wrapper>
      {
        props.items?.map((item, index) => <WizardItem key={index} lastItem={index === props.items.length-1} {...item} />)
      }
    </Wrapper>
  );
};

export interface WizardItemProps {
  numTitle: number;
  title: string;
  active: boolean;
  current: boolean;
}
const WizardItem: FC<WizardItemProps & { lastItem: boolean }> = ({ numTitle, title, active, current, lastItem = false }) => {
  const activeProps = { active, current };
  return (
    <>
    <Circle {...activeProps}>{ numTitle }</Circle>
    <LineWrapper>
      {
        // current && <Line {...activeProps} beginning />
      }
      <Title {...activeProps}>{ title }</Title>
      {
        !lastItem &&
        <Line {...activeProps} />
      }
    </LineWrapper>
    </>
  )
}
